import type { TrackerMessage, TrackerMessageOverview } from '@racemap/sdk/schema/trackers';
import {
  getSentAttempts,
  isMessageClosed,
  isMessageFinalized,
} from '@racemap/utilities/functions/messages';
import type { Immutable } from 'immer';

export const isMessageNotAcknowledged = (
  message: Immutable<TrackerMessageOverview | TrackerMessage>,
): boolean => {
  if (!isMessageClosed(message)) return false;
  if (isMessageFinalized(message)) return false;

  return getSentAttempts(message) >= message.maxNumOfAttempts;
};
